import { useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";

export default function CreateDomain({
  loading,
  showModal,
  onClose,
  onCreate,
}) {
  const [domain, setDomain] = useState({
    domain: "",
  });
  const [showError, setShowError] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    const data = { ...domain };
    data[name] = value;
    setDomain(data);
    setShowError(false);
  };

  const createDomain = () => {
    if (domain?.domain) {
      onCreate(domain);
    } else {
      setShowError(true);
    }
  };
  return (
    <>
      <Modal show={showModal} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Create domain</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Domain</Form.Label>
              <Form.Control
                required
                type="text"
                name="domain"
                value={domain.domain}
                onChange={handleChange}
              />
              {showError && !domain.domain && (
                <Form.Label className="text-warning mt-1">
                  Enter valid domain
                </Form.Label>
              )}
              <Form.Text className="text-muted mt-2">
                <strong>Block domain patterns:</strong>
                <ul className="pl-3 mt-1 mb-0">
                  <li>
                    <code>domain.com</code> — exact match
                  </li>
                  <li>
                    <code>dom*</code> — blocks domains starting with{" "}
                    <code>dom</code>
                  </li>
                  <li>
                    <code>*domain*</code> — blocks domains containing{" "}
                    <code>domain</code>
                  </li>
                  <li>
                    <code>*dom*.com</code> — blocks domains like{" "}
                    <code>mydomsite.com</code>
                  </li>
                </ul>
                Use <code>*</code> as a wildcard. Matching is case-insensitive.
              </Form.Text>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={loading}
            className="btn btn-sm btn-primary rounded-pill mr-auto"
            onClick={createDomain}
          >
            {loading ? (
              <Spinner size="sm" animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            ) : (
              "Save"
            )}
          </Button>

          <Button
            variant="secondary"
            disabled={loading}
            className="btn btn-sm btn-link text-muted px-2"
            onClick={onClose}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
